import App from "../layouts/App";
import colortheoryJpeg from "/colortheory.jpeg";

export default function Home() {
	return (
		<App>
			<main className="AboutMain">
				<div className="AboutDiv">
					<h4 className="HomeT">What Color Did God Create You In?</h4>
					<hr className="Divider" />
					<p className="AboutPara">
						GOD created us on purpose, for a purpose! <br />
						<br />
						As a Reflection of Himself, In His Image! <br />
						<br />
						PERFECT - PURE - HOLY!
						<br />
						<br />
						Value Your "Fruit of The Spirit!" and Find Your True Color!
					</p>

					<h4>
						Please take our "See Your Color Experience"! (Click on the planet above
						(SYCE) )
					</h4>
					<img
						src={colortheoryJpeg}
						alt="Color Theory"
						style={{ width: "675px", height: "auto" }} // Adjust the width and height as needed
					/>
				</div>
			</main>
		</App>
	);
}
